import React from 'react';
import './ProductVisibilityButton.css';

function EyeOpenIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="2.6" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

function EyeClosedIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M3 3l18 18"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M9.9 5.5C10.57 5.34 11.27 5.25 12 5.25c6 0 9.5 6.75 9.5 6.75a16.7 16.7 0 0 1-3.04 3.54"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.7 7.7A16.3 16.3 0 0 0 2.5 12s3.5 6.75 9.5 6.75c1.18 0 2.28-.2 3.28-.55"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function ProductVisibilityButton({
  visible,
  disabled,
  onToggle,
}) {
  const label = visible ? 'Товар виден покупателям' : 'Товар скрыт от покупателей';

  return (
    <button
      type="button"
      className={`product-visibility-button${visible ? '' : ' product-visibility-button--hidden'}`}
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={!!visible}
      aria-label={label}
      title={label}
    >
      {visible ? <EyeOpenIcon /> : <EyeClosedIcon />}
    </button>
  );
}
